import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { project_query } from 'ducks/projects/constants';
import { updateSettings } from 'ducks/settings/slices';
import { Slices } from 'ducks/slices';
import { ProjectsAPI, ProjectsCreateRequestData } from 'ducks/types/api-types';
import { Query } from 'ducks/types/query-types';
import { store } from 'store';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';
import { replaceSearchQuery } from 'utils/queries';

export const getProjects = createAsyncThunk<ProjectsAPI[], Query | undefined>(
  `${Slices.PROJECTS}/get`,
  async (queries = {}, { rejectWithValue }) => {
    try {
      const query = {
        ...project_query,
        ...queries,
      };
      const res: AxiosResponse['data'] = await Andromeda.get(`/projects/list${replaceSearchQuery(query)}`);
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);

export const getProjectsPage = async (queries: Query) => {
  const query = {
    ...project_query,
    ...queries,
  };
  store.dispatch(updateSettings({ loading: true }));
  await store.dispatch(getProjects(query));
  store.dispatch(updateSettings({ loading: false }));
};

export const createProject = async (data: ProjectsCreateRequestData) => {
  const post_data = {
    project_name: data.project_name,
  };
  store.dispatch(updateSettings({ loading: true }));
  const res: AxiosResponse['data'] = await Andromeda.post('/projects/create', post_data);
  return res.data;
};
